import React from "react";

export default function Tasks({ className }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <rect x="3" y="4" width="7" height="16" rx="1.5" />
      <rect x="13" y="4" width="7" height="10" rx="1.5" />
      <path d="m14.5 18 2 2 4-5" />
    </svg>
  );
}
